import React, { Component } from 'react';
import {Col, Container, Row, Stack} from "react-bootstrap";
import { ReactComponent as Arrow } from "../assets/Arrow Left.svg";


class FormOtherFeedback extends Component {


    render() {
        return (
            <Container fluid className="d-flex flex-column Form-body Peach mt-3">
                <Row style={{width: "fit-content"}} className="col-sm d-block d-sm-none">
                    <button  className="prev-button" onClick={() => {this.props.prevStep(2);  this.props.handleValidationTrigger(false);}}><Arrow/> &nbsp; Back</button>
                </Row>
                <Row>
                    <Col>
                        <Stack className="top-row" direction="horizontal" gap={2}>
                            <div className="indicator Active"></div>
                            <div className="indicator Active"></div>
                            <div className="indicator Active"></div>
                        </Stack>
                    </Col>
                </Row>
                <Row className="flex-grow-1 align-items-center middle-row">
                    <Col xs={12} lg={6}>
                        <p className="text">Could you tell us more about what went wrong?</p>
                    </Col>
                    <Col xs={12} lg={6} className="d-flex justify-content-end">
                        <Stack>
                        <textarea className="form-textarea Large" rows="5"
                                  placeholder="Type your answer here (required) ..."
                                  value={this.props.inputValues.disappointmentComment}
                                  onChange={event => (this.props.handleTextChange("disappointmentComment", event.target.value))}
                        ></textarea>
                            {this.props.inputValues.validation && !this.props.inputValues.disappointmentComment ?
                        <span style={{color: 'red', marginTop: "5px"}}>*Field is required</span>: null}
                        </Stack>
                    </Col>
                </Row>
                <Row className="bottom-row align-items-center">
                    <Col style={{padding:"0"}} className="col-sm d-none d-sm-block">
                        <button className="prev-button" onClick={() => {
                            this.props.handleValidationTrigger(false);
                            this.props.prevStep(2)
                        }}>&lt; Previous Question
                        </button>
                    </Col>
                    <Col className="text-end">
                        {this.props.inputValues.disappointmentComment ?
                            <button className="next-button feedback" onClick={() => {
                                this.props.onSubmit()
                            }}>Submit
                            </button>
                            :
                            <button className="next-button feedback disabled" onClick={() => {
                                this.props.handleValidationTrigger(true);
                            }}>Submit
                            </button>
                        }
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default FormOtherFeedback;